;(function() {
/* @ngInject */
function PaymentSectionController(PaymentService, ModalLegaliaPayment, $window) {
    let vm = this;

    let paymentService = PaymentService;

    vm.paymentType = "movement";
    vm.paymentInProgress = false;
    vm.legaliaPayment = null;

    vm.$onInit = onInit;
    vm.isLegalia = isLegalia;
    vm.onPayClick = onPayClick;

    function onInit() {
        if (isLegalia()) {
            paymentService.getLegaliaPaymentSummary(vm.hash)
              .then((paymentData) => {
                  vm.legaliaPayment = paymentData;
              });
        }
    }

    function isLegalia() {
        return vm.businessServicesDodavatelId === "Legalia";
    }

    function onPayClick() {
        if (isLegalia()) {
            if (vm.paymentInProgress) {
                return;
            }

            vm.paymentInProgress = true;
            paymentService.getLegaliaBankTransferData(vm.hash)
              .then((paymentData) => {
                  if (paymentData) {
                      ModalLegaliaPayment(paymentData).add();
                  }
              })
              .finally(() => {
                  vm.paymentInProgress = false;
              });
        } else if(vm.paymentType === "movement") {
            let url = '/bank-transfer/' + vm.hash;
            $window.location = url;
        } else {
            paymentService.pay({paymentType: vm.paymentType, hash: vm.hash}).then((url) => {
                $window.location = url;
            })
        }
    }
}

angular.module("firmaren")
    .component("paymentSection", {
        templateUrl: "/app/shared/payment-section/payment-section.html",
        controller: PaymentSectionController,
        controllerAs: "vm",
        bindings: {
            price: "<",
            hash: "<",
            onlyCash: "<",
            notaryFee: "<",
            businessServicesDodavatelId: "<"
        }
    });
}());
